import React from "react";
import { Container } from "./Container";
import "./styles.scss";
import cart from "../../images/cart.png";

const CardContainer = (props) => {
  const { cardLeft, cardRight, item, price, desc, photo, action } = props;
  const addDefaultSrc = (e) => {
    e.target.src = cart;
  };
  return (
    <Container>
      <div className="card-item">
        <div className="card-item-body">
          <div className="d-flex justify-content-between">
            <div>{cardLeft}</div>
            <div className="item-image-container" onClick={action}>
              <img
                src={photo}
                className="card-item-image-container rounded"
                width="100%"
                alt="deal day"
                onError={addDefaultSrc}
              />
            </div>
            <div>{cardRight}</div>
          </div>
          <div onClick={action}>
            <p className="card-item-item-name">{item}</p>
            <p className="card-item-item-desc">{desc}</p>
            <p className="card-item-item-name">₦ {price}</p>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default CardContainer;
